// extracted by mini-css-extract-plugin
export default {"ns_account_google_login":"AccountGoogleLogin_ns_account_google_login__3d9++"};